import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import { Gynecology2Sidebar } from "../Layouts/Gynecology2Sidebar";
import axios from "axios";
import $ from "jquery";

export class G2PhysicalExaminationPelvic extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      GE: "",
      Vagina: "",
      Cervix: "",
      CervixPosition: "",
      Effacement: "",
      Dilatation: "",
      Consistence: "",
      PresentationType: "",
      Position: "",
      EngagementVarieties: "",
      Station: "",
      Membrane: "",
      TimeDateRupture: "",
      AmnioticFluid: "",
      VaginalBleeding: "",
      VaginalBleedingAmount: "",
      Color: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(localStorage.getItem("accessToken"));
    console.log(this.state);
    axios
      .post(
        this.api_url+"gynecology2/physicalexam/pelvic",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            window.location.href = "/gynecology2/history/taking";
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      GE,
      Vagina,
      Cervix,
      CervixPosition,
      Effacement,
      Dilatation,
      Consistence,
      PresentationType,
      Position,
      EngagementVarieties,
      Station,
      Membrane,
      TimeDateRupture,
      AmnioticFluid,
      VaginalBleeding,
      VaginalBleedingAmount,
      Color,
    } = this.state;
    return (
      <div>
        <Headers />
        <Gynecology2Sidebar />

        <main className="content-container ">
          <div className="container pl-5">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row ">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Pelvic Examination and PV:
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      GE
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={GE}
                      name="GE"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Cervix
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Cervix}
                      name="Cervix"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Vagina
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Vagina}
                      name="Vagina"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Cervix Position
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={CervixPosition}
                      name="CervixPosition"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Effacement
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Effacement}
                      name="Effacement"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Dilatation
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Dilatation}
                      name="Dilatation"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Consistence
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Consistence}
                      name="Consistence"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Presentation Type
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={PresentationType}
                      name="PresentationType"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Position
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Position}
                      name="Position"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Engagement Varieties
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={EngagementVarieties}
                      name="EngagementVarieties"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Station
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Station}
                      name="Station"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Membrane
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Membrane}
                      name="Membrane"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Time Date Rupture
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={TimeDateRupture}
                      name="TimeDateRupture"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Amniotic Fluid
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={AmnioticFluid}
                      name="AmnioticFluid"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Vaginal Bleeding
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={VaginalBleeding}
                      name="VaginalBleeding"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Vaginal Bleeding Amount
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={VaginalBleedingAmount}
                      name="VaginalBleedingAmount"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Color
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Color}
                      name="Color"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Physical Examination Pelvic Saved
                Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default G2PhysicalExaminationPelvic;
